export enum RulesOutputsTitles {
  requirements = 'DECLINE REASON (if rule FAILS)',
  scorecard = 'Output (if rule passes)',
  output = 'Output (if rule passes)',
}
